import React from 'react';
import { faShop } from '@fortawesome/pro-solid-svg-icons/faShop';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ShopSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faShop} {...props} />;
}
